<template>

    <body>
        <div class="modalContainer active loginModal formsModal">
            <div class="actualModal">
                <router-link to="/index" class="closeModal"><i class="fal fa-times"></i></router-link>
                <form @submit.prevent="handleSubmit" class="modalBodyOfItem">
                    <div class="itemBodyLeftModal">
                        <h4>Sign Up</h4>
                        <p class="formPara" style="text-align: center;">
                            Creating an account will let you store multiple shipping
                            addresses, gain access to your order history, order status and
                            much more.
                        </p>
                        <div class="inputsContainer">
                            <div class="individualInput">
                                <h5>Email Address</h5>
                                <input v-model="email" type="text" name="" id="email" placeholder="email@example.com" />
                            </div>
                            <div class="individualInput">
                                <h5>Password</h5>
                                <input v-model="password" type="password" name="" id="password"
                                    placeholder="*******************" />
                                <!-- <span class="passStrength">Medium</span> -->
                            </div>
                            <!-- <div class="individualInput"> -->
                            <input type="checkbox" v-model="terms"> I agree to the <a target="-_blank" href="/#/tts">Terms of Use
                            </a></input>
                            <!-- </div> -->
                        </div>
                        <div class="mobileFlex"></div>

                        <div class="quickCheckout">
                            <div style="margin-bottom: 5px;" v-if="haserrors" class="error">Please complete the form.
                            </div>
                            <button type="submit">Create Account</button>
                        </div>
                        <div class="formBtm">
                            <router-link to="/login" class="signUpBtn">Already have an account? Sign in</router-link>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </body>
</template>
<script>
import validator from 'validator'
    export default {
        name: 'SignUp',
        data() {
            return {
                haserrors: false,
                terms: true,
                name: '',
                email: '',
                password: '',
                token: this.$route.query.token
            }
        },
        methods: {
          validateForm() {
            let {email,password} = this
            let isEmail = validator.isEmail(email)
            if(!isEmail || !password || password.length < 8) return false
            return true
          },
            handleSubmit(e) {
                console.log('form submitted')
                if (!this.terms) return
                this.submitted = true
                const {
                    name,
                    email,
                    password,
                    phone,
                    token
                } = this
                const {
                    dispatch
                } = this.$store
                if (email && password) {
                  if(!this.validateForm()) {
                    this.haserrors = true
                    return console.error('invalid form.')
                  }
                    console.log(`dispatching register`)
                    dispatch('auth/register', {
                        name,
                        email,
                        password,
                        phone,
                        token,
                        redirect: '/signup1'
                    })
                } else {
                    this.haserrors = true
                }
            }
        },
        watch: {
            '$route'(to, from) {
                // react to route changes...
                this.token = this.$route.query.token
            }
        }

    }
</script>
<style>
    .sign-up-page-wrapper {
        padding: 5px;
    }
</style>
